import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {Label} from './label'
import {buildItemPickersUrl} from '@github-ui/item-picker-base/api/urls'

export type CreateLabelRequest = {
  repositoryId: string
  name: string
  color: string
}

type CreateLabelResponseData = {
  createLabel: {
    label: Label
  }
}

export type CreateLabelResponse = GraphQLResponse<CreateLabelResponseData>

export async function apiCreateLabel(request: CreateLabelRequest): Promise<CreateLabelResponse> {
  const pathname = buildItemPickersUrl('labels')

  const init = {
    method: 'POST',
    body: request,
  }

  const response = await verifiedFetchJSON(pathname, init)
  return response.json() as Promise<CreateLabelResponse>
}
